import {Component} from '@verndale/core';
import countryCodes from "../helpers/countryPhoneCodes";

class Dropdown extends Component {
  constructor(el) {
    super(el);
    this.selectedListItem = null;
    this.storedValue = null;
  }

  setupDefaults() {
    const form = this.el.closest('.Form__MainBody').parentElement;
    this.phonePrefix = form.querySelector('.FormPhoneCode__Code');
    this.phoneLabel = this.phonePrefix?.parentElement?.querySelector('.Form__Element__Caption');

    this.dom = {
      input: this.el.querySelector('.dropdown__input'),
      label: this.el.querySelector('.Form__Element__Caption'),
      listElement: this.el.querySelector('.dropdown__list'),
      listItems: this.el.querySelectorAll('.dropdown__list-item'),
      hiddenSelect: this.el.querySelector('.dropdown__hidden-select'),
    };

    this.dom.listElement.style.display = 'none';

    if (!this.dom.hiddenSelect.value) {
      return;
    }
    this.resetList();
    const selectedValue = this.dom.hiddenSelect.value;

    this.dom.input.value = this.dom.hiddenSelect.options[this.dom.hiddenSelect.selectedIndex].text;
    this.storedValue = selectedValue;
    this.clearSelected();
    this.dom.listElement.style.display = 'none';
    this.setActive();
    this.setPhonePrefixOnLoad();
    this.setSelectValue();
    this.storedValue = null;
  }

  addListeners() {
    this.dom.input.addEventListener('click', () => {
      this.dom.listElement.style.display = 'block';
      this.dom.input.value = '';
    });

    this.dom.input.addEventListener('input', (e) => {
      this.inputValue = e.target.value;

      this.filterOptions(this.inputValue);
      this.dom.listElement.style.display = this.inputValue ? 'block' : 'none';

      if (this.inputValue.length > 2) {
        this.clearSelected();
        this.setActive();
      }
    });

    this.dom.listElement.addEventListener('click', (event) => {
      if (event.target.classList.contains('dropdown__list-item')) {
        this.resetList();
        const selectedValue = event.target.getAttribute('data-value');

        this.dom.input.value = event.target.textContent;
        this.storedValue = selectedValue;
        this.clearSelected();
        this.dom.listElement.style.display = 'none';
        this.setActive();
        this.setPhonePrefix();
        this.setSelectValue();
        this.storedValue = null;
      }
    });

    this.dom.input.addEventListener('keydown', (event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.navigateList(event.key);

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          this.dom.listElement.style.display = 'block';
        }

      } else if (event.key === 'Enter' && this.selectedListItem) {
        event.preventDefault();
        const selectedValue = this.selectedListItem.getAttribute('data-value');

        this.dom.input.value = this.selectedListItem.textContent;
        this.storedValue = selectedValue;
        this.clearSelected();
        this.dom.listElement.style.display = 'none';
        this.setPhonePrefix();
        this.setSelectValue();
        this.storedValue = null;

      } else if (event.key === 'Escape') {

        this.dom.listElement.style.display = 'none';
        this.clearSelected();

        this.dom.input.value = '';
        this.storedValue = null;
      } else if (event.key === 'Tab' && !this.storedValue) {
        this.resetList();
        this.dom.input.value = '';
        this.dom.listElement.style.display = 'none';
        this.clearSelected();
        this.storedValue = null;
      }
    }));

    document.addEventListener('click', (event) => {
      const isClickInsideDropdown = this.el.contains(event.target);
      const isClickInsideList = this.dom.listElement.contains(event.target);

      if (!isClickInsideDropdown && !isClickInsideList) {

        if (this.storedValue === null) {
          this.dom.listElement.style.display = 'none';
          this.clearSelected();
        } else {
          this.dom.listElement.style.display = 'none';
        }
      }
    });
  }

  setActive() {
    this.dom.label.classList.add('is-active');
  }

  navigateList(direction) {
    const currentArray = this.inputValue ? this.filteredOptions : [...this.dom.listItems];
    let currentIndex = this.inputValue ? currentArray.indexOf(this.reset ? this.filteredOptions[0] : this.selectedListItem) : currentArray.indexOf(this.selectedListItem);

    if (direction === 'ArrowDown' && currentIndex < currentArray.length - 1) {
      currentIndex += 1;
    } else if (direction === 'ArrowUp' && currentIndex > 0) {
      currentIndex -= 1;
    }

    this.clearSelected();

    if (currentArray[currentIndex]) {
      currentArray[currentIndex].classList.add('selected');
      this.selectedListItem = currentArray[currentIndex];
      this.dom.listElement.scrollTop = this.selectedListItem.offsetTop;
      this.reset = false;
    }

  }

  clearSelected() {
    if (this.selectedListItem) {
      this.selectedListItem.classList.remove('selected');
      this.selectedListItem = null;
    }
  }

  resetList() {
    [...this.dom.listItems].forEach((item) => {
      item.style.display = 'block';
      item.removeAttribute('tabindex')
    });
  }

  filterOptions(value) {
    this.filteredOptions = Array.from(this.dom.listItems).filter((item) => item.textContent.toLowerCase().includes(value.toLowerCase()));

    this.dom.listItems.forEach((item) => {
      item.style.display = 'none';
      item.tabIndex = -1;
    });

    this.filteredOptions.forEach((item) => {
      item.style.display = 'block';
      item.removeAttribute('tabindex')
    });

    this.reset = true;
  }

  setSelectValue() {
    if (this.storedValue) {
      this.dom.hiddenSelect.value = this.storedValue;

      // trigger change event manually to make sure opti form dependency works 
      const changeEvt = new Event("change");
      this.dom.hiddenSelect.dispatchEvent(changeEvt);
    }
  }

  setPhonePrefix() {
    if (this.phonePrefix) {
      this.phonePrefix.value = `+${countryCodes[this.storedValue]}`;
      this.phonePrefix.focus();
    }
  }

  setPhonePrefixOnLoad() {
    if (!this.phonePrefix) {
      return;
    }

    // Do not overwrite the phone prefix value if it exists
    if (this.phonePrefix.value) {
      return;
    }

    this.phonePrefix.value = `+${countryCodes[this.storedValue]}`;

    if (this.phonePrefix.value) {
      this.phoneLabel.classList.add('is-active');
    }
  }
}

export default Dropdown;
